module.exports = __webpack_public_path__ + "static/media/Spoink_gaussian2.fe20d18b.png";